import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const StatusFilter = () => {
  const [selectedStatus, setSelectedStatus] = useState("");
  const status = [
    { value: "pending", label: "قيد الانتظار" },
    { value: "accepted", label: "مقبولة" },
    { value: "rejected", label: "مرفوضة" },
  ];
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const statusParam = params.get("status");
    if (statusParam) {
      setSelectedStatus(statusParam);
    } else {
      setSelectedStatus("");
    }
  }, [location.search]);

  const handleFilter = (e) => {
    const newStatus = e.target.value;
    const params = new URLSearchParams(location.search);

    if (newStatus === "") {
      params.delete("status");
    } else {
      params.set("status", newStatus);
    }
    params.delete("page");

    navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  };
  return (
    <select
      className="rounded-md bg-blueSecondary py-1 px-3 text-white"
      onChange={handleFilter}
      value={selectedStatus}
      name="status"
    >
      <option value="">الكل</option>
      {status.map((item, index) => (
        <option key={index} value={item.value}>
          {item.label}
        </option>
      ))}
    </select>
  );
};

export default StatusFilter;
